import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle } from "lucide-react";
import { useI18n } from "../lib/LanguageContext";

export function PaymentSuccess() {
  const { t } = useI18n();
  const [sp] = useSearchParams(); const sessionId = sp.get("session_id");
  const [status, setStatus] = useState("polling"); const { refresh } = useAuth();
  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const iv = setInterval(async () => {
      tries++;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); clearInterval(iv); await refresh(); }
        else if (tries > 15) { setStatus("timeout"); clearInterval(iv); }
      } catch { }
    }, 2000);
    return () => clearInterval(iv);
  }, [sessionId, refresh]);
  return (
    <div className="max-w-md mx-auto py-24 px-6" data-testid="payment-success">
      <Card className="rounded-2xl p-8 text-center border-teal/20">
        {status==="paid" ? <>
          <CheckCircle2 className="w-14 h-14 text-teal mx-auto mb-3"/>
          <h1 className="font-display text-2xl font-medium mb-2">{t("payment.success")}</h1>
          <p className="text-muted-foreground text-sm">{t("payment.welcome")}</p>
        </> : status==="timeout" ? <>
          <XCircle className="w-14 h-14 text-orange-500 mx-auto mb-3"/>
          <h1 className="font-display text-2xl mb-2">{t("payment.pending")}</h1>
          <p className="text-muted-foreground text-sm">{t("payment.check_email")}</p>
        </> : <>
          <div className="w-10 h-10 border-4 border-teal border-t-transparent rounded-full animate-spin mx-auto mb-4"/>
          <p>{t("payment.verifying")}</p>
        </>}
        <Link to="/nuna"><Button className="mt-6 rounded-full bg-teal hover:bg-teal/90 text-white">{t("payment.go_nuna")}</Button></Link>
      </Card>
    </div>
  );
}

export function PaymentCancel() {
  const { t } = useI18n();
  return (
    <div className="max-w-md mx-auto py-24 px-6" data-testid="payment-cancel">
      <Card className="rounded-2xl p-8 text-center">
        <XCircle className="w-14 h-14 text-orange-500 mx-auto mb-3"/>
        <h1 className="font-display text-2xl mb-2">{t("payment.cancelled")}</h1>
        <p className="text-muted-foreground text-sm mb-6">{t("payment.retry")}</p>
        <Link to="/harga"><Button className="rounded-full bg-teal hover:bg-teal/90 text-white">{t("payment.back_pricing")}</Button></Link>
      </Card>
    </div>
  );
}
